import { RoutePath } from 'shared/constants/router';

export const ADMIN_ROUTES = [
  RoutePath.StudentObserver,
  RoutePath.AdminSchoolLinks,
  RoutePath.SchoolLinksManager,
];
